import React from 'react';
import { SelectionCell } from '@/components/ui';
import TextCell from '@/components/ui/TextCell';
import { IconLocationPin } from '@repo/svgs';
import { NycAutocompleteSuggestion } from '@repo/api';
import { useStore } from '@/providers/StoreProvider';
import { useAnalytics } from '@/hooks/useAnalytics';

export function BuildingSuggestions({ suggestions }: { suggestions: NycAutocompleteSuggestion[] }) {
  if (!suggestions || suggestions.length === 0) return null;
  const analytics = useAnalytics();
  const setBuilding = useStore(s => s.listingsFilters.setBuilding);
  const resetBuilding = useStore(s => s.listingsFilters.resetBuilding);
  const building = useStore(s => s.listingsFilters.building);

  return (
    <div className="flex flex-col gap-2">
      <TextCell className="w-full">Addresses</TextCell>
      <div className="flex flex-col gap-1">
        {suggestions.map(s => {
          const isSelected = building?.slug === s.buildingSlug || building?.addressSlug === s.slug;
          return (
            <SelectionCell
              key={s.placeId}
              title={s.streetAddress}
              subtitle="Address"
              selected={isSelected}
              leadingIcon={<IconLocationPin className="w-6 h-6 icon-secondary" />}
              onToggle={() => {
                analytics.track('listings_filter_building');
                if (isSelected) {
                  resetBuilding();
                  return;
                }
                setBuilding({
                  addressSlug: s.slug,
                  slug: s.buildingSlug,
                  address: s.streetAddress,
                });
              }}
            />
          );
        })}
      </div>
    </div>
  );
}

export default BuildingSuggestions;
